
import { Building, ArrowRight, Users, Award } from "lucide-react";

const HistoireContent = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-white to-fabre-lightgray">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-heading font-bold mb-6 text-fabre-gray">
              Une aventure entrepreneuriale familiale
            </h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8 rounded-full"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="flex items-center mb-4">
                  <Building className="h-6 w-6 text-fabre-green mr-3" />
                  <h3 className="text-xl font-semibold text-fabre-gray">Nos origines</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Depuis plus de 35 ans, le Groupe Fabre développe son pôle Environnement afin de promouvoir une approche responsable de la gestion des déchets, tout en offrant des services efficaces et fiables.
                </p>
              </div>
              
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="flex items-center mb-4">
                  <ArrowRight className="h-6 w-6 text-fabre-teal mr-3" />
                  <h3 className="text-xl font-semibold text-fabre-gray">Notre expansion</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  L'implantation de nos sites renforce notre présence territoriale et permet d'améliorer nos flux de déchets dans une logique d'économie circulaire et d'optimisation de leurs valorisations.
                </p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="flex items-center mb-4">
                  <Users className="h-6 w-6 text-fabre-gold mr-3" />
                  <h3 className="text-xl font-semibold text-fabre-gray">Notre croissance</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Notre pôle Environnement continue de croître et devient une branche de plus en plus importante au sein du Groupe Fabre.
                </p>
              </div>
              
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="flex items-center mb-4">
                  <Award className="h-6 w-6 text-fabre-darkteal mr-3" />
                  <h3 className="text-xl font-semibold text-fabre-gray">Nos projets futurs</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  De nombreux projets à venir pour nous permettre de réduire notre consommation d'énergie, de recycler nos déchets et d'être moins dépendants des énergies fossiles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HistoireContent;
